import { ofType, Epic } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, mergeMap, map } from "rxjs/operators";
import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import { searchList } from "../../../service/list-search.api";
import { getTrackedList } from "../../../service/tracked-list.api";
import {
    ListBuilderListActionType,
    listBuilderListSuccessAction,
    listBuilderListErrorAction,
    listBuilderListGetTrackedListsSuccessAction,
    listBuilderListGetTrackedListsErrorAction,
    IListBuilderListActions,
    listBuilderListGetAction,
    listBuilderListGetTrackedListsAction,
    listBuilderListGetTrackedListsNextPageAction,
} from "./list-builder-list.actions";

const MAX_LISTS = 15000;
const MAX_TRACKED_LISTS = 1000;

export const listBuilderListEpic: Epic<IAction, IAction, IRootState> = (
    action$,
) =>
    merge(
        action$.pipe(
            ofType<
                IListBuilderListActions,
                ListBuilderListActionType.LIST_BUILDER_LIST_INIT
            >(ListBuilderListActionType.LIST_BUILDER_LIST_INIT),
            mergeMap(() => [
                listBuilderListGetAction(),
                listBuilderListGetTrackedListsAction(),
            ]),
        ),
        action$.pipe(
            ofType<
                IListBuilderListActions,
                ListBuilderListActionType.LIST_BUILDER_LIST_GET
            >(ListBuilderListActionType.LIST_BUILDER_LIST_GET),
            mergeMap(() =>
                searchList("", selectAuthTokens(), MAX_LISTS, true).pipe(
                    map((lists) => listBuilderListSuccessAction(lists)),
                    catchError((error: IErrorDto) =>
                        of(listBuilderListErrorAction(error.message)),
                    ),
                ),
            ),
        ),
        action$.pipe(
            ofType<
                IListBuilderListActions,
                ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS
            >(ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS),
            map(() =>
                listBuilderListGetTrackedListsNextPageAction(null, 0, null),
            ),
        ),
        action$.pipe(
            ofType<
                IListBuilderListActions,
                ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE
            >(
                ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE,
            ),
            mergeMap((action) => {
                if (
                    action.payload.total === null ||
                    action.payload.total > action.payload.offset
                ) {
                    return getTrackedList(
                        {
                            offset: action.payload.offset,
                            limit: MAX_TRACKED_LISTS,
                        },
                        selectAuthTokens(),
                    ).pipe(
                        map((response) =>
                            listBuilderListGetTrackedListsNextPageAction(
                                response.lists,
                                action.payload.offset + MAX_TRACKED_LISTS,
                                response.total,
                            ),
                        ),
                        catchError((error: IErrorDto) =>
                            of(
                                listBuilderListGetTrackedListsErrorAction(
                                    error.message,
                                ),
                            ),
                        ),
                    );
                }
                return [listBuilderListGetTrackedListsSuccessAction()];
            }),
        ),
    );
